import * as types from './types'

const state = {
  [types.STATE_TABS]: [],
}

export default state
